var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 18H4c-1.103 0-2-.898-2-2v-4a.666.666 0 111.333 0v4c0 .368.299.666.667.666h12a.667.667 0 00.666-.666v-4A.666.666 0 1118 12v4c0 1.102-.898 2-2 2",
    fill: "#191C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.102 2.008l.048.01a.66.66 0 01.042.01l.005.002a.33.33 0 01.04.013 1.069 1.069 0 01.091.043l.044.028c.02.012.04.027.058.043l.01.01.031.027.012.014 3.98 3.98c.26.261.26.682 0 .943a.668.668 0 01-.942 0l-2.855-2.854v8.39c0 .366-.3.666-.666.666a.669.669 0 01-.667-.666V4.275L6.477 7.13a.668.668 0 01-.942 0 .668.668 0 010-.943l3.98-3.98a.665.665 0 01.29-.178c.013-.005.026-.008.038-.011a.648.648 0 01.149-.02L9.998 2c.036 0 .07.002.104.008z",
    fill: "#3B65EE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/assets/export.d95f68eb.svg";
export { ForwardRef as ReactComponent };